
import { defineComponent } from '@vue/composition-api';
import PageSection from '~/components/storyblok/PageSection/PageSection.vue';

const pgData = {
  _uid: '874310b8-22b6-4b42-9bea-87ccbbe97236',
  codeId: 'BoxingWorkouts_OurTrainers',
  height: 'auto',
  scroll: '',
  component: 'PageSection',
  container: [
    {
      _uid: '01e7fc06-4f39-44fc-b0c2-5fe6b8dfbcb5',
      codeId: '',
      component: 'GeneralContent',
      paddingTop: 'fc-padding-top-5',
      paddingLeft: '',
      paddingRight: '',
      containerSize: '',
      paddingBottom: 'fc-padding-bottom-5',
      contentPosition: '',
      contentContainer: [
        {
          _uid: '92a66057-f960-4088-a107-9d628394b98d',
          text: 'Meet Our Trainers',
          codeId: '',
          isBold: false,
          component: 'ShortText',
          textColor: 'black',
          textTheme: 'title',
          paddingTop: 'fc-padding-top-2',
          isUpperCase: false,
          paddingLeft: 'fc-padding-left-0',
          paddingRight: 'fc-padding-right-0',
          paddingBottom: 'fc-padding-bottom-4',
          textAlignment: 'fc-text-center',
          _editable: '\u003C!--#storyblok#{"name": "ShortText", "space": "152150", "uid": "7902d742-68f9-4e3c-82f7-4a3a1d99a4b4", "id": "262640079"}--\u003E',
        },
        {
          _uid: '76ab1ead-755b-440a-9401-6aba5c821635',
          text: 'Our trainers are the real deal. With decades of experience and plenty of personality to keep you motivated. They’ll push you to your limits.',
          codeId: '',
          isBold: false,
          maxWidth: '47rem',
          component: 'ShortText',
          textColor: 'black',
          textTheme: 'text',
          paddingTop: 'fc-padding-top-0',
          isUpperCase: false,
          paddingLeft: 'fc-padding-left-0',
          paddingRight: 'fc-padding-right-0',
          paddingBottom: 'fc-padding-bottom-5',
          textAlignment: 'fc-text-center',
          _editable: '\u003C!--#storyblok#{"name": "ShortText", "space": "152150", "uid": "5c764193-8f8f-4026-a3eb-3c51b18fbf93", "id": "262640079"}--\u003E',
        },
        {
          _uid: '015190db-46b5-43b0-bf22-d9347336a203',
          mode: 'threeSlideView',
          label: 'Trainer Carouse',
          slides: [
            {
              _uid: 'beeb7b88-a27e-43aa-a1a7-1600de483197',
              label: 'TommyDuquette',
              component: 'CarouselSlide',
              thumbnails: [
                {
                  _uid: 'a509f9a6-8b07-4af7-a289-74c490dd02d6',
                  name: 'Tommy Duquette',
                  focus: '20+ years of coaching experience',
                  career: '2012 US Olympic Trials, #2 Seed',
                  component: 'TrainerThumbnail',
                  experience: '4-time US National Boxing Team member',
                  profileImage: {
                    id: 17146415,
                    alt: 'FightCamp trainer Tommy Duquette',
                    name: '',
                    focus: '',
                    title: '',
                    source: '',
                    filename: 'https://a.storyblok.com/f/152150/624x624/52160f3690/fc-trainer-tommy-duquette-001.png',
                    copyright: '',
                    fieldtype: 'asset',
                    meta_data: {
                      alt: 'FightCamp trainer Tommy Duquette',
                      title: '',
                      source: '',
                      copyright: '',
                    },
                    is_external_url: false,
                  },
                  _editable: '\u003C!--#storyblok#{"name": "TrainerThumbnail", "space": "152150", "uid": "a509f9a6-8b07-4af7-a289-74c490dd02d6", "id": "262640079"}--\u003E',
                },
              ],
              _editable: '\u003C!--#storyblok#{"name": "CarouselSlide", "space": "152150", "uid": "beeb7b88-a27e-43aa-a1a7-1600de483197", "id": "262640079"}--\u003E',
            },
            {
              _uid: '865b051b-2478-4ddb-83a0-b8b38ce7b4c8',
              label: 'JessicaEvans',
              component: 'CarouselSlide',
              thumbnails: [
                {
                  _uid: '6626e856-ebbf-4dd2-b379-e20081a8da4a',
                  name: 'Jessica Evans',
                  focus: 'Focus on technique & performance',
                  career: '10+ yrs as a coach & fitness trainer',
                  component: 'TrainerThumbnail',
                  experience: '12 yrs of international boxing & kickboxing',
                  profileImage: {
                    id: 17146419,
                    alt: 'FightCamp trainer Jess Evans',
                    name: '',
                    focus: '',
                    title: '',
                    source: '',
                    filename: 'https://a.storyblok.com/f/152150/624x624/b0dfc64e02/fc-trainer-jess-evans-001.png',
                    copyright: '',
                    fieldtype: 'asset',
                    meta_data: {
                      alt: 'FightCamp trainer Jess Evans',
                      title: '',
                      source: '',
                      copyright: '',
                    },
                    is_external_url: false,
                  },
                  _editable: '\u003C!--#storyblok#{"name": "TrainerThumbnail", "space": "152150", "uid": "6626e856-ebbf-4dd2-b379-e20081a8da4a", "id": "262640079"}--\u003E',
                },
              ],
              _editable: '\u003C!--#storyblok#{"name": "CarouselSlide", "space": "152150", "uid": "865b051b-2478-4ddb-83a0-b8b38ce7b4c8", "id": "262640079"}--\u003E',
            },
            {
              _uid: 'e757df89-6f0c-45bc-b0bc-feee1ac2a681',
              label: 'PJShirdan',
              component: 'CarouselSlide',
              thumbnails: [
                {
                  _uid: '9b14a0ef-2033-4066-aa23-0aae71dc24c1',
                  name: 'PJ Shirdan',
                  focus: 'Certified USA Boxing Coach, NASM CPT, ACE, GFI',
                  career: '20+ yrs of coaching experience',
                  component: 'TrainerThumbnail',
                  experience: '15+ yrs of boxing experience',
                  profileImage: {
                    id: 17146420,
                    alt: 'FightCamp trainer PJ Shirdan',
                    name: '',
                    focus: '',
                    title: '',
                    source: '',
                    filename: 'https://a.storyblok.com/f/152150/624x624/01b9617945/fc-trainer-pj-shirdan-001.png',
                    copyright: '',
                    fieldtype: 'asset',
                    meta_data: {
                      alt: 'FightCamp trainer PJ Shirdan',
                      title: '',
                      source: '',
                      copyright: '',
                    },
                    is_external_url: false,
                  },
                  _editable: '\u003C!--#storyblok#{"name": "TrainerThumbnail", "space": "152150", "uid": "9b14a0ef-2033-4066-aa23-0aae71dc24c1", "id": "262640079"}--\u003E',
                },
              ],
              _editable: '\u003C!--#storyblok#{"name": "CarouselSlide", "space": "152150", "uid": "e757df89-6f0c-45bc-b0bc-feee1ac2a681", "id": "262640079"}--\u003E',
            },
            {
              _uid: '92bdbf21-ff75-47a5-b01c-927f4f694817',
              label: 'Charlotte Craig',
              component: 'CarouselSlide',
              thumbnails: [
                {
                  _uid: '7eab1e8b-000c-47cf-a154-3fc40e33ee84',
                  name: 'Charlotte Craig',
                  focus: '15+ years coaching experience',
                  career: 'Professional MMA fighter',
                  component: 'TrainerThumbnail',
                  experience: '13-time US National Team member',
                  profileImage: {
                    id: 17146416,
                    alt: 'FightCamp trainer Charlotte Craig',
                    name: '',
                    focus: '',
                    title: '',
                    source: '',
                    filename: 'https://a.storyblok.com/f/152150/624x624/a050ea4e01/fc-trainer-charlotte-craig-001.png',
                    copyright: '',
                    fieldtype: 'asset',
                    meta_data: {
                      alt: 'FightCamp trainer Charlotte Craig',
                      title: '',
                      source: '',
                      copyright: '',
                    },
                    is_external_url: false,
                  },
                  _editable: '\u003C!--#storyblok#{"name": "TrainerThumbnail", "space": "152150", "uid": "7eab1e8b-000c-47cf-a154-3fc40e33ee84", "id": "262640079"}--\u003E',
                },
              ],
              _editable: '\u003C!--#storyblok#{"name": "CarouselSlide", "space": "152150", "uid": "92bdbf21-ff75-47a5-b01c-927f4f694817", "id": "262640079"}--\u003E',
            },
            {
              _uid: '1cb84bbd-4248-466c-9ca9-23491f19c65b',
              label: 'FLOMASTER',
              component: 'CarouselSlide',
              thumbnails: [
                {
                  _uid: 'fdfe291c-55da-4350-ab42-2e9d7a62cf4a',
                  name: 'FLOMASTER',
                  focus: 'Personal trainer to Usher, Will Smith, Justin Bieber & more',
                  career: '30+ yrs fitness experience',
                  component: 'TrainerThumbnail',
                  experience: 'Purple belt in Brazilian Jiu Jitsu',
                  profileImage: {
                    id: 17146418,
                    alt: 'FightCamp trainer Flow Master',
                    name: '',
                    focus: '',
                    title: '',
                    source: '',
                    filename: 'https://a.storyblok.com/f/152150/624x624/57ab4df5e7/fc-trainer-flow-master-001.png',
                    copyright: '',
                    fieldtype: 'asset',
                    meta_data: {
                      alt: 'FightCamp trainer Flow Master',
                      title: '',
                      source: '',
                      copyright: '',
                    },
                    is_external_url: false,
                  },
                  _editable: '\u003C!--#storyblok#{"name": "TrainerThumbnail", "space": "152150", "uid": "fdfe291c-55da-4350-ab42-2e9d7a62cf4a", "id": "262640079"}--\u003E',
                },
              ],
              _editable: '\u003C!--#storyblok#{"name": "CarouselSlide", "space": "152150", "uid": "1cb84bbd-4248-466c-9ca9-23491f19c65b", "id": "262640079"}--\u003E',
            },
            {
              _uid: 'f2ad29e5-41e4-4c73-8f82-96e097fd218f',
              label: 'Aaron',
              component: 'CarouselSlide',
              thumbnails: [
                {
                  _uid: '519173a3-0384-48cc-827f-0f9f91a5c960',
                  name: 'Aaron Swenson',
                  focus: '15+ yrs as a coach, NASM certified',
                  career: '34 fights (Boxing, Kickboxing and Muay Thai)',
                  component: 'TrainerThumbnail',
                  experience: '2-time National Kickboxing Champion',
                  profileImage: {
                    id: 17146414,
                    alt: 'FightCamp trainer Aaron Swenson',
                    name: '',
                    focus: '',
                    title: '',
                    source: '',
                    filename: 'https://a.storyblok.com/f/152150/624x624/1a04cf55c5/fc-trainer-aaron-swenson-001.png',
                    copyright: '',
                    fieldtype: 'asset',
                    meta_data: {
                      alt: 'FightCamp trainer Aaron Swenson',
                      title: '',
                      source: '',
                      copyright: '',
                    },
                    is_external_url: false,
                  },
                  _editable: '\u003C!--#storyblok#{"name": "TrainerThumbnail", "space": "152150", "uid": "519173a3-0384-48cc-827f-0f9f91a5c960", "id": "262640079"}--\u003E',
                },
              ],
              _editable: '\u003C!--#storyblok#{"name": "CarouselSlide", "space": "152150", "uid": "f2ad29e5-41e4-4c73-8f82-96e097fd218f", "id": "262640079"}--\u003E',
            },
            {
              _uid: 'a4200ae8-70fd-4b53-8122-72a609dfa1cf',
              label: 'Selina Flores',
              component: 'CarouselSlide',
              thumbnails: [
                {
                  _uid: '1989e813-2547-4b1a-81a2-c87c12e15e89',
                  name: 'Selina Flores',
                  focus: 'Tough, no nonsense coaching style',
                  career: '10+ yrs of coaching experience ',
                  component: 'TrainerThumbnail',
                  experience: 'Professional Muay Thai Fighter',
                  profileImage: {
                    id: 17146417,
                    alt: 'FightCamp trainer Selina Flores',
                    name: '',
                    focus: '',
                    title: '',
                    source: '',
                    filename: 'https://a.storyblok.com/f/152150/624x624/3654e331e7/fc-trainer-selina-flores-001.png',
                    copyright: '',
                    fieldtype: 'asset',
                    meta_data: {
                      alt: 'FightCamp trainer Selina Flores',
                      title: '',
                      source: '',
                      copyright: '',
                    },
                    is_external_url: false,
                  },
                  _editable: '\u003C!--#storyblok#{"name": "TrainerThumbnail", "space": "152150", "uid": "1989e813-2547-4b1a-81a2-c87c12e15e89", "id": "262640079"}--\u003E',
                },
              ],
              _editable: '\u003C!--#storyblok#{"name": "CarouselSlide", "space": "152150", "uid": "a4200ae8-70fd-4b53-8122-72a609dfa1cf", "id": "262640079"}--\u003E',
            },
          ],
          component: 'Carousel',
          contentWrap: 'default',
          activeMobile: true,
          activeDesktop: false,
          hideNavigation: false,
          staticHorizontalOffset: 'min(20rem, 20%)',
          _editable: '\u003C!--#storyblok#{"name": "Carousel", "space": "152150", "uid": "015190db-46b5-43b0-bf22-d9347336a203", "id": "262640079"}--\u003E',
        },
      ],
      tabletUpPaddingTop: 'md:fc-padding-top-8',
      tabletUpPaddingLeft: '',
      tabletUpPaddingRight: '',
      contentContainerWidth: '',
      tabletUpPaddingBottom: '',
      _editable: '\u003C!--#storyblok#{"name": "GeneralContent", "space": "152150", "uid": "01e7fc06-4f39-44fc-b0c2-5fe6b8dfbcb5", "id": "262640079"}--\u003E',
    },
  ],
  elementId: '',
  minHeight: '',
  contentWrap: '',
  inContainer: false,
  backgroundColor: 'white',
  _editable: '\u003C!--#storyblok#{"name": "PageSection", "space": "152150", "uid": "874310b8-22b6-4b42-9bea-87ccbbe97236", "id": "262640079"}--\u003E',
};

export default defineComponent({
  name: 'OurTrainers',
  components: {
    PageSection,
  },
  setup() {
    return { pgData };
  },
});
